import React from 'react'
import { LogosProps } from './Interfaces'
import { useContext } from 'react'
import conferLogo from '../../assets/images/Confer Logo.svg'
import scarlattiLogo from '../../assets/images/scarlatti-logo.svg'
import { SettingsContext } from '@confer/lib'
import styled from 'styled-components'

export const Logos = (props: LogosProps) => {
  const { logos, hide, justify } = props
  const settings = useContext(SettingsContext)
  return (
    <LogoRow hide={hide} justify={justify}>
      {logos.map((item, index) => (
        <LogoContainer key={item.path} height={item.height}>
          <img key={item.path} src={item.path} alt={item.altText || 'logo'} />
        </LogoContainer>
      ))}
      {settings.hideProviderLogos ? null : (
        <LogoContainer height="65px">
          <a href="https://scarlatti.co.nz/" target="_blank" rel="noreferrer">
            <img src={scarlattiLogo} alt="Scarlatti" />
          </a>
          <svg height="100%" width="2px">
            <Line x1="0" y1="0" x2="0" y2="100%" />
          </svg>
          <a
            href="https://scarlatti.co.nz/service-areas/social-and-market-research/clever-data-collection-with-confer/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={conferLogo} alt="Confer" />
          </a>
        </LogoContainer>
      )}
    </LogoRow>
  )
}

interface LogoRowProps {
  hide?: boolean
  justify?: 'start' | 'center' | 'end' | 'space-between' | 'space-around' | 'space-evenly'
}

const Line = styled.line`
  stroke: var(--mid-light);
  stroke-width: 2px;
`

const LogoRow = styled.div<LogoRowProps>`
  display: ${(props) => (props.hide ? 'none' : 'flex')};
  flex-direction: row;
  justify-content: ${(props) => (props.justify ? props.justify : 'space-between')};
  align-items: center;
  width: 100%;
  overflow: hidden;
  min-height: 0;
  top: 0px;
`

interface LogoContainerProps {
  height?: string
}

const LogoContainer = styled.div<LogoContainerProps>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  min-height: 0;
  padding: 20px;
  height: ${(props) => props.height ?? '75px'};
  img {
    object-fit: contain;
    height: 100%;
    width: 100%;
  }
  a {
    height: 100%;
  }
  gap: 10px;
`
